import { render } from "./ModuleManagement.vue?vue&type=template&id=6cedccb9&scoped=true"
import script from "./ModuleManagement.vue?vue&type=script&lang=js"
export * from "./ModuleManagement.vue?vue&type=script&lang=js"

import "./ModuleManagement.vue?vue&type=style&index=0&id=6cedccb9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cedccb9"

export default script